"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function languagesImporterWebpack(requireContext) {
  const lists = {};
  requireContext.keys().forEach(file => {
    // Getting file body
    const fileBody = requireContext(file); // Trying to extract file name

    const fileCode = file.replace(/\.\/(.*)\.json/, '$1'); // Regex for finding nested path after regular file name transform

    const subDirReg = new RegExp(/^(.*\/)(.*)$/); // Trying to extract file for possible nested file

    const subLibCode = fileCode.replace(subDirReg, '$2'); // Really checking is dealing with a nested file

    const nestedDirectoryFile = subDirReg.test(fileCode); // Assigning correct language code

    const langCode = !nestedDirectoryFile ? fileCode : subLibCode; // If there're already entries for current language, merge on same body. Otherwise create new entry

    if (langCode in lists) {
      Object.assign(lists[langCode], fileBody);
    } else {
      Object.assign(lists, {
        [langCode]: fileBody
      });
    }
  });
  return lists;
}

var _default = languagesImporterWebpack;
exports.default = _default;